import { SectionHeader } from "@/components/ui/SectionHeader";
import { UseCaseList } from "@/components/ui/UseCaseList";

const USE_CASES = [
  {
    title: "ゲーム・アプリの入金",
    body: "ユーザーが日本円を銀行振込で入金し、アプリ内残高をステーブルコインで受け取る 日本円→ステーブルコイン フロー。Intent API を組み込むだけで、既存プロダクトにオンランプ機能を追加できます。",
  },
  {
    title: "換金（キャッシュアウト）",
    body: "ユーザーが保有するステーブルコインを専用アドレスへ送付し、日本円の銀行振込で受け取る ステーブルコイン→日本円 フロー。Redemption API により、複雑なオフランプ処理を自動化します。",
  },
  {
    title: "報酬・インセンティブ配布",
    body: "キャンペーン報酬やリワードをステーブルコインで配布し、希望者は Redemption で日本円に換金。プログラマブルな報酬設計と、受取手段の柔軟性を両立できます。",
  },
  {
    title: "プラットフォーム型サービス",
    body: "マーケットプレイスやトレーディングプラットフォームにおける日本円の入出金を簡素化。Intent / Redemption の双方向フローで、チェーン決済との接続を一元管理できます。",
  },
  {
    title: "運用・監査",
    body: "Admin API でユーザー情報・トランザクション履歴・ステーブルコイン 残高情報を参照し、障害対応や入出金の照合に活用。運用チームのオペレーションを効率化します。",
  },
];

export function MbscUseCases() {
  return (
    <section className="px-6 py-20 md:px-12">
      <div className="mx-auto max-w-4xl">
        <SectionHeader
          eyebrow="Use Cases"
          title="MBSCを活用したさまざまなユースケース"
          description="日本円→ステーブルコイン（Intent）と ステーブルコイン→日本円（Redemption）の双方向フローにより、さまざまな業種・業態の日本円 ↔ ステーブルコイン連携を実現します。"
        />
        <UseCaseList items={USE_CASES} className="mt-12" />
      </div>
    </section>
  );
}
